import React from 'react';
import Icon from './MCIcon';

export default class FAIcon extends Icon {
    /** @override **/
    baseClassName = 'fa';
}

